export default __webpack_public_path__ + "77a3e0f569fa5e55aaa3923c99bf0a84.svg";